/**
 * @generated SignedSource<<845eba47df6a5f309c0b62091bc310af>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NftItemImportErrorReason = "NFT_ITEM_IMPORT_ERROR_REASON_DUPLICATE_ID" | "NFT_ITEM_IMPORT_ERROR_REASON_INVALID_MEDIA" | "NFT_ITEM_IMPORT_ERROR_REASON_INVALID_METADATA" | "NFT_ITEM_IMPORT_ERROR_REASON_MEDIA_PROCESSING_ERROR" | "NFT_ITEM_IMPORT_ERROR_REASON_UNKNOWN_ERROR" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type NftProfileImportCollectionRetry_nftItem$data = {
  readonly importErrorReason: NftItemImportErrorReason | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "NftProfileImportCollectionRetry_nftItem";
};
export type NftProfileImportCollectionRetry_nftItem$key = {
  readonly " $data"?: NftProfileImportCollectionRetry_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftProfileImportCollectionRetry_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftProfileImportCollectionRetry_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "importErrorReason",
      "storageKey": null
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "d48104afbb0fc74e9e48242fb068915c";

export default node;
